
exports.StringToBooleanOrderTransformer = () => {
  return {
    convertToVersionOne : (bool) => bool.toString(),
    convertToVersionTwo : (string) => string === 'true'
  }
}


// WEBPACK FOOTER //
// ./node_modules/@abc/transformers/src/transformers/order/boolean/index.js